import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getName } from "../../store/services/tokenFunc";
import { APP_PDC_URL } from "../../config";
import { FormattedMessage } from "react-intl";

import { clearDetail } from "../../store/actions/detailsDocument/index";
import { getDocumentsWithSearch } from "../../store/actions/documentsWithSearch/index";

import Filters from "./sideFilters/";
import TopControls from "./topFilters/";
import Results from "./results/";

import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";

const DocumentsWithSearch = props => {
  const {
    accountantIdSelected,
    accountantSelected,
    clientIdSelected,    
    myType,
    prevPath
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const [clickedSearch, setClickedSearch] = useState(false);
  // grid or list. La prima per la visualizzazione a card, la seconda per la lista a tutta larghezza
  const [documentView, setDocumentView] = useState(localStorage.getItem("documentViewType")
    ? localStorage.getItem("documentViewType")
    : "list");
  const [scrollPage, setScrollPage] = useState(0);
  const [documentsLoaded, setDocumentsLoaded] = useState(false);

  const auth = useSelector(state => state.auth);
  const companies = useSelector(state => state.company.companies);
  const detailsDocument = useSelector(state => state.detailsDocument);
  const currentLink = useSelector(state => state.documentsWithSearch.currentLink);
  const filters = useSelector(state => state.documentsWithSearch.filters);
  const firstLink = useSelector(state => state.documentsWithSearch.firstLink);
  const isGettingDocumentsWithSearch = useSelector(state => state.documentsWithSearch.isGettingDocumentsWithSearch);
  const links = useSelector(state => state.documentsWithSearch.links);
  const results = useSelector(state => state.documentsWithSearch.results);
  const txtSearch = useSelector(state => state.documentsWithSearch.txtSearch);

  const dispatch = useDispatch();

  const handleGetDocumentsWithSearch = ({ link = null, isAppend = false, additionalProps = null, removeProps = [], search = "", reset = false }) => {

    return dispatch(getDocumentsWithSearch(
      link,
      search,
      isAppend,
      additionalProps,
      removeProps,
      reset
    )).then(r => {}).catch(err => {
      
      console.log(err);
    });
  };

  const handleScroll = () => {
    let scrollPageCalc =
      window.pageYOffset > 0 && location.pathname === "/documenti"
        ? window.pageYOffset
        : scrollPage;
    localStorage.setItem("scrollHeight", scrollPageCalc);
    setScrollPage(scrollPageCalc);
  };

  useEffect(() => {
    // initiate the event handler
    window.addEventListener("scroll", handleScroll);
    // this will clean up the event every time the component is re-rendered
    return function cleanup() {
      window.removeEventListener("scroll", handleScroll);
    };
  },[]);

  useEffect(() => {
    /** Per evitare il caricamento in dettaglio del documento precedente per una frazione di secondo */
    if (!detailsDocument.previewDetails.content) return;
    clearDetail();
  }, [detailsDocument.previewDetails.content]);

  useEffect(() => {
    let scrollYInfo = localStorage.getItem("scrollHeight");
    /** Se arrivo dal dettaglio allora non ricarico i documenti ma riporto l'utente nella sua ultima posizione  */
    if (
      results.list &&
      prevPath.match(/dettaglio-documento/) &&
      results.list.length > 0
    ) {
      if (scrollYInfo) {
        window.scrollTo(0, scrollYInfo);
        localStorage.removeItem("scrollHeight");
      }
      return;
    }

    if (isGettingDocumentsWithSearch || txtSearch !== "") return;
    if (
      !results.list ||
      results.list.length === 0 ||
      !prevPath.match(/dettaglio-documento/) ||
      !prevPath.match(/documenti/)
    ) {
      /** serve ad atterrare su un dato filtro della macrocategoria arrivando da un link su diversa rotta */
      let historyMacro =
        location.state &&
          location.state.macro &&
          (!firstLink || prevPath !== location.pathname)
          ? location.state.macro
          : false;

      let historyCategory =
        location.state && location.state.category;

      if (historyMacro) {
        let directLink = "";
        /** mi costruisco il currentLink per applicare il filtro */
        if (firstLink) {
          directLink =
            location.state && location.state.macro !== "Tutti"
              ? firstLink +
              "&macrocategory=" +
              location.state.macro +
              "&onlyUnread=" +
              true
              : firstLink + "&onlyUnread=" + true;

          /** controllo che accountant e company selezionate siano quelle correnti
           * succede talvota che firstLink contenga ancora il primo link una volta cambiata azienda o commercialista
           */
          let url = new URL(directLink);
          url.searchParams.set("accountantId", accountantIdSelected);
          url.searchParams.set("itemId", clientIdSelected);
          directLink = url.href;
        } else {
          directLink =
          APP_PDC_URL +
            "/v2/documents?accountantId=" +
            accountantIdSelected +
            "&itemId=" +
            clientIdSelected +
            "&prefix=&macrocategory=" +
            location.state.macro +
            "&onlyUnread=" +
            true;
        }
        handleGetDocumentsWithSearch({
          link: directLink
        }).then(() => {
          setDocumentsLoaded(true);
        });
        navigate(location.pathname, { state: { macro: false }, replace: true });
      } else if (historyCategory) {
        let directLink = "";
        /** mi costruisco il currentLink per applicare il filtro */
        if (firstLink) {
          directLink =
            firstLink +
            // Attenzione se reintroduco il prefix non funziona + l'ordinamento!
            //   "&prefix=" +
            //   location.state.category +
            "&category=" +
            location.state.category +
            "&macrocategory=" +
            location.state.macrocategory +
            "&sortOnField=" +
            location.state.sortOnField +
            "&sortOrder=" +
            location.state.sortOrder;
          /** controllo che accountant e company selezionate siano quelle correnti
           * succede talvota che firstLink contenga ancora il primo link una volta cambiata azienda o commercialista
           */
          let url = new URL(directLink);
          url.searchParams.set("accountantId", accountantIdSelected);
          url.searchParams.set("itemId", clientIdSelected);
          directLink = url.href;
        } else {
          directLink =
          APP_PDC_URL +
            "/v2/documents?accountantId=" +
            accountantIdSelected +
            "&itemId=" +
            clientIdSelected +
            "&category=" +
            location.state.category +
            "&macrocategory=" +
            location.state.macrocategory +
            "&sortOnField=" +
            location.state.sortOnField +
            "&sortOrder=" +
            location.state.sortOrder;
        }
        handleGetDocumentsWithSearch({
          link: directLink
        }).then(() => {
          setDocumentsLoaded(true);
        });
        navigate(location.pathname, {
          state: {
            category: false,
            macrocategory: false,
            sortOnField: false,
            sortOrder: false
          }, replace: true
        });
      } else {

        let linkAccountant = currentLink
          ? new URL(currentLink).searchParams.get("accountantId")
          : null;
        let linkCompany = currentLink
          ? new URL(currentLink).searchParams.get("itemId")
          : null;

        /** se torno indietro da un dettaglio e avevo attivato un filtro,
         * questo deve mantenersi attivo. Altrimenti devo fare una richiesta da zero
         * */
        currentLink &&
          linkAccountant === accountantSelected &&
          linkCompany === clientIdSelected
          ? handleGetDocumentsWithSearch({
            link: currentLink
          }).then(() => {
            setDocumentsLoaded(true);
          })
          : handleGetDocumentsWithSearch({}).then(() => {
            setDocumentsLoaded(true);
          });
      }
    }
  }, [firstLink]);

  const getOtherResults = () => {
    handleGetDocumentsWithSearch({
      link: links.href
    }).then(() => {
      setDocumentsLoaded(true);
    });
  };

  const changeView = typeView => {
    localStorage.setItem("documentViewType", typeView);
    setDocumentView(typeView);
  };

  let getMeInfoCompany = companies
    ? companies.find(el => {
      return el.id === clientIdSelected;
    })
    : null;

  let ragioneSociale = getMeInfoCompany
    ? getMeInfoCompany.ragioneSociale
    : null;
  const morningMessage = (
    <h2 style={{ textAlign: "center" }} className="noMessageDocs">
      {" "}
      <FormattedMessage id="generic.goodMorning" />{" "}
      {getName(auth.loginAuth.securityToken)}! <br />
      <FormattedMessage id="documents.noDocuments_1" /> {ragioneSociale}{" "}
      <FormattedMessage id="documents.noDocuments_2" />.
    </h2>
  );
  // Se ci sono documenti devo mettere questa variabile sul localStorage, per evitare problemi nell'apertura
  // del dettaglio documento dopo il cambio azienda
  if (results && results.list && results.list.length > 0) {
    localStorage.setItem("ragsoc", ragioneSociale);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {results.status.ended === true &&
        results.list &&
        results.list.length === 0 &&
        currentLink === firstLink ? (
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            {!clickedSearch ? (
              morningMessage
            ) : (
              <h2>
                <FormattedMessage id="documents.noResults_1" /> "{txtSearch}".{" "}
                <FormattedMessage id="documents.noResults_2" />.
              </h2>
            )}
          </div>
        ) :
        (<div>
          <TopControls
            handleGetDocumentsWithSearch={handleGetDocumentsWithSearch}
            changeView={changeView}
            documentView={documentView}
            macroCategories={
              filters.list &&
              filters.list.find(el => el.title === "Macro Categoria")
            }
            updateState={setClickedSearch}
          />
          <div className="flexRow100">
            <div className="containerFilters">
              <Filters
                handleGetDocumentsWithSearch={handleGetDocumentsWithSearch}
              />
            </div>
            <div
              style={
                documentView === "grid"
                  ? {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "flex-start"
                  }
                  : { width: "100%" }
              }
            >
              <div style={{ paddingTop: "16px" }}>
                {results.status.started && (!results.list || results.list.length < 1) ? (
                  <div style={{ textAlign: "center", marginTop: "42px" }}>
                    <Spin
                      indicator={<FontAwesomeIcon icon={["far", "circle-notch"]} spin />}
                      size="large"
                      tip={<span><FormattedMessage id="generic.loading1" /> <FormattedMessage id="generic.loading2" /></span>}
                      style={{ fontSize: "20px" }}
                    />
                  </div>
                ) : (
                  <React.Fragment>
                    <Results
                      documentView={documentView}                      
                      myType={myType}
                      documentsLoaded={documentsLoaded}
                    />
                    {results.status.ended === true &&
                      results.list &&
                      results.list.length > 0 &&
                      links && (
                      <div
                        className="buttonInfiniteScroll"
                        onClick={getOtherResults}
                      >
                        <FormattedMessage id="documents.showMore" />
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
        )}
    </div>
  );
};
export default DocumentsWithSearch;
